// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { CartProvider } from './context/CartContext';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './App.css';

// // Components
// import Header from './components/Header';
// import Footer from './components/Footer';
// import Faq from './pages/Faq';
// import ShippingPolicy from './pages/ShippingPolicy';
// import ReturnPolicy from './pages/ReturnPolicy';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import Terms from './pages/Terms';
// // Pages
// import Home from './pages/Home';
// import Shop from './pages/Shop';
// import About from './pages/About';
// import Cart from './pages/Cart';
// import Checkout from './pages/Checkout';
// import NotFound from './pages/NotFound';
// import ProductDetail from './pages/ProductDetail';
// import FloatingButtons from './components/FloatingButtons';
// import OrderConfirmation from './pages/OrderConfirmation';

// function App() {
//   return (
//     <CartProvider>
//       <Router>
//         <div className="min-h-screen flex flex-col bg-pink-50">
//           <Header />
//           <main className="flex-grow">
//             <Routes>
            
//   <Route path="/" element={<Home />} />
//   <Route path="/shop" element={<Shop />} />
//   <Route path="/about" element={<About />} />
//   <Route path="/cart" element={<Cart />} />
//   <Route path="/checkout" element={<Checkout />} />




// <Route path="/faq" element={<Faq />} />
// <Route path="/shipping-policy" element={<ShippingPolicy />} />
// <Route path="/return-policy" element={<ReturnPolicy />} />
// <Route path="/privacy-policy" element={<PrivacyPolicy />} />
// <Route path="/terms" element={<Terms />} />

// <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />

//   <Route path="/product/:type/:id" element={<ProductDetail />} />
  
 
//   <Route path="*" element={<NotFound />} />
// </Routes>
           
//           </main>
//           <FloatingButtons/>
//           <Footer />
//           <ToastContainer position="bottom-right" />
//         </div>
//       </Router>
//     </CartProvider>
//   );
// }

// export default App;












import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
 
import Faq from './pages/Faq';
import ShippingPolicy from './pages/ShippingPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
// Pages
import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import NotFound from './pages/NotFound';
import ProductDetail from './pages/ProductDetail';
import FloatingButtons from './components/FloatingButtons';
import OrderConfirmation from './pages/OrderConfirmation';
 import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Admin from './admin/Admin';



const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
    },
  },
});





function App() {
  return (
        <QueryClientProvider client={queryClient}>

  <CartProvider>
      <Router>
        <div className="min-h-screen flex flex-col bg-pink-50">
          <ScrollToTop /> {/* ✅ Add this line */}
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/about" element={<About />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />






{/* ADMIN */}

            <Route path="/admin" element={<Admin  />} />

{/* ADMIN */}





              <Route path="/faq" element={<Faq />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
              <Route path="/product/:type/:id" element={<ProductDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <FloatingButtons/>
          <Footer />
          <ToastContainer position="bottom-right" />
        </div>
      </Router>
    </CartProvider>

        </QueryClientProvider>
  
  );
}

export default App;














 
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
    
    // Optional: Smooth scroll
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth'
    // });
  }, [pathname]);

  return null;
};

 